<template>
    <div v-if="table">

        <view-header v-if="(!model.supportMobile || model.viewModel.renderType !== 'Mobile') && showHeader" :table="table" :view="view" :parent-table="parentTable"
                     :parent-document="parentDocument"></view-header>


        <div class="row mx-0 h-100">

            <app-config v-if="model.supportMobile" :view="view"></app-config>

            <div class="bg-light" :class="model.supportMobile ? 'col-8' : 'col-12'">

                <phone-container v-if="model.supportMobile && model.viewModel.renderType === 'Mobile'" :view="view">

                    <template v-slot:header>
                        <div class="d-flex justify-content-between p-2">
                            <div></div>
                            <div>{{view.name}}</div>
                            <div></div>
                        </div>
                    </template>

                    <list-view :view="view" :view-model="model.viewModel" :table="table" :documents="documents"
                               style="height: 600px; overflow-y: scroll;"></list-view>

                    <mobile-tabs-container :view="view"  v-slot:tabNav></mobile-tabs-container>
                </phone-container>

                <list-view v-else :view="view" :view-model="model.viewModel" :table="table" :documents="documents"></list-view>
            </div>

            <layout-property-editor v-if="model.supportMobile && table && layout" class="bg-white"
                                    :view-model="model.viewModel" :layout="layout" :view="view"
                                    :table="table" :config="listConfig"></layout-property-editor>

        </div>

    </div>
</template>

<script>
    import ModelService from "../../services/ModelService";
    import ArrayUtil from "../../utils/ArrayUtil";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import ListItem from "./ListItem.vue";
    import ViewService from "../../services/ViewService";
    import ViewHeader from "../ViewHeader.vue";
    import DataService from "../../services/DataService";
    import ListItemActions from "../../components/ListItemActions.vue";
    import PhoneContainer from "../../components/PhoneContainer.vue";
    import LayoutPropertyEditor from "../../editor/experimental/LayoutPropertyEditor.vue";
    import ListView from "./ListView.vue";
    import AppConfig from "../../editor/experimental/AppConfig.vue";
    import MobileTabsContainer from "../../editor/experimental/MobileTabsContainer.vue";

    export default {
        name: 'ListContainer',
        components: {
            MobileTabsContainer,
            AppConfig,
            ListView,
            LayoutPropertyEditor,
            PhoneContainer,
            ListItemActions,
            ViewHeader,
            ListItem,
            ConfirmModal
        },
        props: {
            view: Object,
            table: Object,
            parentTable: Object,
            parentDocument: Object,
            showHeader: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                model: webase.model,
                service: new ModelService(),
                dataService: new DataService(this.table.id),
                arrayUtil: new ArrayUtil(),
                documents: [],
                showConfirmModal: false,
                deleteDocument: function () {
                }
            }
        },
        computed: {
            layout() {
                return this.view.layout
            },
            isChildList() {
                return this.parentTable && this.parentDocument ? true : false
            },
            currentView() {
                return this.view || this.table.views[0]
            },
            // authorized() {
            //     return webase.managers.permission.fullAccess() || webase.managers.permission.authorized(this.parentTable, this.parentDocument)
            // },
            parentTableId() {
                return this.parentTable ? this.parentTable.id : null
            },
            parentDocumentId() {
                return this.parentDocument ? this.parentDocument['id'] : null
            },
            listConfig() {
                // TODO: what do we need here?
                return {}
                //return this.model.viewModel.renderType === 'Mobile' ? this.layout.gallery.mobile : this.layout.gallery.desktop
            },
        },
        mounted() {
            if(this.view) {
                this.loadDataFromView()
            }
            else {
                this.loadDataFromTable()
            }

            webase.eventDispatcher.on('viewUpdated', this.handleViewUpdate)
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.handleViewUpdate)
        },
        methods: {
            loadDataFromTable() {
                if (this.parentDocument) {
                    this.loadChildData()
                } else {
                    this.loadDocuments()
                }
            },
            loadDataFromView() {
                let viewService = new ViewService()
                let relatedField = null

                if(this.table && this.parentTable) {
                    relatedField = webase.utils.table.getRelatedField(this.table, this.parentTable.system_id)
                }

                viewService.getData(this.view, this.table, this.parentDocumentId, relatedField).then((response) => {
                    this.documents = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            loadDocuments() {
                this.dataService.get().then((response) => {
                    this.documents = response
                }).catch((message) => {
                    console.log('error loading dat from table')
                    console.log(message)
                })
            },
            loadChildData() {
                this.dataService.get(this.parentDocumentId).then((response) => {
                    this.documents = response
                }).catch((message) => {
                    console.log('error loading table')
                    console.log(message)
                })
            },
            onDeleteClick(document) {
                this.showConfirmModal = true
                this.deleteDocument = () => {
                    this.dataService.remove(document).then((response) => {
                        this.showConfirmModal = false
                        this.arrayUtil.remove(this.documents, document['id'])
                    }).catch((message) => {
                        console.log('error deleting document')
                        console.log(message)
                        this.showConfirmModal = false
                    })
                }
            },
            handleViewUpdate(view) {
                if(this.view.id === view.id) {
                    this.loadDataFromView()
                }
            },
            isAuthorized(document) {
                if (webase.managers.permission.fullAccess()) {
                    return true
                }

                return webase.managers.permission.isAuthorized(this.table, document, this.parentTable, this.parentDocument)
            }
        }
    }
</script>

<style>

</style>
